import { createBootActor } from './boot-machine'
import type { BootActor } from './boot-provider'
import { markBootPhases, resetBootMarkState } from './boot-marks'

let appBootActor: BootActor | undefined
let stopMarking: (() => void) | undefined

/** The one boot actor for this page. Created and started on first use. */
export const getAppBootActor = (): BootActor => {
    if (!appBootActor) {
        appBootActor = createBootActor()
        appBootActor.start()
        stopMarking = markBootPhases(appBootActor)
    }

    return appBootActor
}

/** Stops and discards the actor so the next mount boots from the first phase. */
export const resetAppBootActorForTests = (): void => {
    stopMarking?.()
    stopMarking = undefined
    appBootActor?.stop()
    appBootActor = undefined
    resetBootMarkState()
}
